window.PopUpCreater = (function () {
    let close = function (event) {
        let target = event.target;
        let closestPopUpContent = target.closest('.popUp-content');
        if (closestPopUpContent) {
            closestPopUpContent.classList.add('fade-out');
        }

        setTimeout(function () {
            let fadeOutPopUpContents = document.querySelectorAll('.popUp-content.fade-out');
            fadeOutPopUpContents.forEach(function (popUpContent) {
                popUpContent.remove();
            });

        }, 500);

        if (document.querySelectorAll('.popUp-content:not(.fade-out)').length === 0) {
            document.body.classList.remove('fade-in');
            setTimeout(function () {
                if (document.querySelectorAll('.popUp-content:not(.fade-out)').length === 0) {
                    document.body.classList.remove('popUp-overlayed');
                    let PopUpContainer = document.getElementById('PopUpContainer');
                    let popUpOverlay = document.getElementById('popUpOverLay');
                    if (PopUpContainer) {
                        PopUpContainer.remove();
                    }
                    if (popUpOverlay) {
                        popUpOverlay.remove();
                    }
                }
            }, 500);
        }
    };
    let open = function (heading, body, evenbinding, className) {
        let html = '';

        let hasHeader = typeof heading !== "undefined" && heading !== null && heading.length !== "";
        if (hasHeader) {
            heading = heading.trim();
            html += '<h2 class="mpa-wp-subheader">' + heading + "</h2>";
        }

        let hasBody = typeof body !== "undefined" && body !== null && body.length > 0;
        if (hasBody) {
            html += '<div class="mpa-wp-body">' + body + "</div>";
        }

        if (typeof evenbinding !== "function") {
            html += '<div class="mpa-wp-controls">' +
                '<input class="mpa-button" type="button" value="' + evenbinding + '" />' +
                '</div>';
        }

        let popUpOverlay = document.getElementById('popUpOverLay');
        if (!popUpOverlay) {
            popUpOverlay = document.createElement('div');
            popUpOverlay.id = 'popUpOverLay';
            document.body.appendChild(popUpOverlay);

            popUpOverlay.style.height = window.innerHeight + 'px';
            popUpOverlay.addEventListener('click', function (event) {
                let popUpContents = document.querySelectorAll('.popUp-content');
                popUpContents.forEach(function (popUpContent) {
                    popUpContent.classList.add('fade-out');
                });
                close(event);
            });

            setTimeout(function () {
                popUpOverlay.classList.add('fade-in');
            }, 50);
        }

        let PopUpContainer = document.getElementById('PopUpContainer');
        if (!PopUpContainer) {
            PopUpContainer = document.createElement('div');
            PopUpContainer.id = 'PopUpContainer';
            PopUpContainer.className = 'wrapper';
            popUpOverlay.appendChild(PopUpContainer);
            PopUpContainer.addEventListener('click', function (event) {
                if (isInsidePopUpContent(event.target)) {
                    event.stopPropagation();
                }
            });
        }

        let jpopUp = document.createElement('div');
        jpopUp.tabIndex = 0;
        jpopUp.className = 'popUp-content' + (typeof className !== "undefined" && className !== null ? ' ' + className : '');
        jpopUp.innerHTML = html;
        PopUpContainer.appendChild(jpopUp);
        jpopUp.classList.add('fade-in');

        if (typeof evenbinding === "function") {
            evenbinding(jpopUp);
        }
        else {
            let mpaButtons = jpopUp.querySelectorAll('.mpa-button');
            mpaButtons.forEach(function (button) {
                button.addEventListener('click', function (e) {
                    e.preventDefault();
                    close(e);
                });
            });
        }

        jpopUp.focus();

        document.body.classList.add("popUp-overlayed");
        document.body.classList.add("fade-in");

        PopUpContainer.scrollTop = 0;
    };

    let isInsidePopUpContent = function (element, i = 0) {
        if (element.classList.contains("popUp-content")) {
            return true;
        }

        let parent = element.parentElement;

        if (!parent || parent.tagName == "BODY" || parent.id == "popUpOverLay" || i > 5) {
            return false;
        }

        return isInsidePopUpContent(parent, i + 1);
    }
    let reactToResize = function () {
        let popUpOverlay = document.querySelector("#popUpOverLay");
        if (popUpOverlay) {
            popUpOverlay.style.height = window.innerHeight + "px";
            popUpOverlay.scrollTop = 0;
        }
    };

    let resizeTimer;
    window.addEventListener('resize', function () {
        reactToResize();
        if (resizeTimer) {
            clearTimeout(resizeTimer);
        }

        resizeTimer = setTimeout(function () {
            reactToResize();
        }, 50);
    });

    return _ = {
        open: open,
        close: close
    }
})();
